import type { FC, ReactElement } from 'react';

import testId from '@snowit/utils/testId';

import ButtonIcon from '../../Buttons/ButtonIcon';
import Typo from '../../Typography/Typo';

import cx from 'classnames';
import s from './PaginationTable.module.scss';

export interface IPaginationTable {
  currentPage: number;
  totalPage: number;
  prevOnclick: (...args: any[]) => void;
  nextOnclick: (...args: any[]) => void;
  id?: string;
  classNames?: {
    wrapper?: string;
  };
  /** Jest/Cypress test string */
  test?: string;
}

const PaginationTable: FC<IPaginationTable> = (props: IPaginationTable): ReactElement => {
  const { currentPage, totalPage, nextOnclick, prevOnclick, id, classNames, test } = props;

  const renderButton = (type: 'prev' | 'next') => {
    return (
      <ButtonIcon
        icon={type === 'prev' ? 'arrow_angle_left' : 'arrow_angle_right'}
        disabled={
          (type === 'prev' && currentPage === 1) || (type === 'next' && currentPage === totalPage)
        }
        onClick={type === 'prev' ? prevOnclick : nextOnclick}
        theme={'transparent'}
        size={'db'}
        color={'text'}
      />
    );
  };

  return (
    <div className={cx(s.wrapper, classNames?.wrapper)} id={id} {...testId(test)}>
      {renderButton('prev')}
      <Typo text={currentPage} tag={'span'} size={'md'} color={'text'} />
      <Typo className={s.total} text={totalPage} tag={'span'} size={'md'} color={'text-l'} />
      {renderButton('next')}
    </div>
  );
};

export default PaginationTable;
